<template>
  <el-datepicker
    class="date-picker"
    :type="type"
    :range-separator="rangeSeparator"
    :value="jsDateValue"
    @input="handleChange($event)"
    :format="datePickerFormat"
    :disabled="disabled"
  ></el-datepicker>
</template>

<script>
import { DatePicker } from "element-ui";
import { DateTime } from "luxon";

export default {
  components: {
    "el-datepicker": DatePicker
  },
  props: ["type", "rangeSeparator", "value", "format", "disabled"],
  computed: {
    datePickerFormat() {
      if (!this.format) {
        return "dd MMMM yyyy";
      }

      return this.format;
    },
    jsDateValue() {
      if (!this.value) {
        return null;
      }

      if (Array.isArray(this.value)) {
        return this.value.map(this.toTHJSDate);
      }

      return this.toTHJSDate(this.value);
    }
  },
  methods: {
    toTHJSDate(dateTime) {
      return dateTime.setZone("utc+7").toJSDate();
    },
    toDateTimeUTC(jsDate) {
      if (!jsDate) {
        return null;
      }

      return DateTime.fromJSDate(jsDate).toUTC();
    },
    handleChange(value) {
      if (Array.isArray(value)) {
        const [start, end] = value.map(this.toDateTimeUTC);

        this.$emit("input", [
          start,
          end
            .setZone("utc+7")
            .endOf("day")
            .toUTC()
        ]);
        return;
      }

      this.$emit("input", this.toDateTimeUTC(value));
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
</style>



// WEBPACK FOOTER //
// src/lib/components/DatePicker.vue